<template>
  <div class="ui-container">
    <div class="number" ref="number">{{ item.num }}</div>
    <!-- 图片容器 -->
    <div class="img-container">
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img1.png')"
        alt=""
        class="img img-1"
        ref="img-1"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img2.png')"
        alt=""
        class="img img-2"
        ref="img-2"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img1.png')"
        alt=""
        class="img img-1"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img2.png')"
        alt=""
        class="img img-2"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img3.png')"
        alt=""
        class="img img-3"
        ref="img-3"
      />
      <!-- <img
        :src="require('../../../assets/main/' + item.fileName + '/img3.png')"
        alt=""
        class="img img-3"
      /> -->
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img4.png')"
        alt=""
        class="img img-4"
        ref="img-4"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img5.png')"
        alt=""
        class="img img-5"
        ref="img-5"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img6.png')"
        alt=""
        class="img img-6"
        ref="img-6"
      />
      <img
        :src="require('../../../assets/main/' + item.fileName + '/img7.png')"
        alt=""
        class="img img-7"
        ref="img-7"
      />
    </div>
    <div class="name">{{ item.name }}</div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([
        this.$refs['img-1'],
        this.$refs['img-2'],
        this.$refs['img-3'],
        this.$refs['img-4'],
        this.$refs['img-5'],
        this.$refs.number,
      ])
    },
    methods: {
      init() {
        //   动画时间线
        let tl = this.$animejs.timeline({
          easing: 'easeInQuad',
        })
        tl.add({
          targets: this.$refs['img-1'],
          translateY: [-300, 0],
          scale: [2, 1],
          opacity: [0.5, 1],
          duration: 1000,
        })
          .add(
            {
              targets: this.$refs['img-2'],
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            100
          )
          .add(
            {
              targets: this.$refs['img-3'],
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            200
          )
          .add(
            {
              targets: this.$refs['img-4'],
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            300
          )
          .add(
            {
              targets: this.$refs['img-5'],
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            400
          )
        //   后续动画
        setTimeout(() => {
          this.$animejs.remove([
            this.$refs['img-1'],
            this.$refs['img-2'],
            this.$refs['img-3'],
          ])
          this.$animejs({
            targets: this.$refs['img-1'],
            scale: [1, 1.5],
            opacity: [1, 0.8, 0.5, 0],
            duration: 2000,
            easing: 'linear',
            loop: true,
          })
          this.$animejs({
            targets: this.$refs['img-2'],
            scale: [1, 1.5],
            opacity: [1, 0.8, 0.5, 0],
            duration: 2000,
            easing: 'linear',
            loop: true,
          })
          this.$animejs({
            targets: this.$refs['img-3'],
            scale: [1, 1.5],
            opacity: [1, 0.8, 0.5, 0],
            duration: 2000,
            easing: 'linear',
            loop: true,
          })
          // 光环动画
          //   this.$animejs({
          //     targets: this.$refs['img-4'],
          //     rotate: [0, 360],
          //     // rotateY: [180, 180],
          //     duration: 2000,
          //     easing: 'linear',
          //     loop: true,
          //     translateY: [-10, -10],
          //   })
          //   this.$animejs({
          //     targets: this.$refs['img-5'],
          //     rotateY: [0, 360],
          //     duration: 2000,
          //     easing: 'linear',
          //     loop: true,
          //   })
        }, 2000)
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.num],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ui-container {
    .number {
      font-size: 1.1458vw;
      color: white;
      text-align: center;
    }
    .img-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      height: 6vh;
      .img {
        position: absolute;
      }
      .img-1 {
        width: 1.979vw;
        bottom: 0.5208vw;
      }
      .img-2 {
        width: 2.708vw;
        bottom: 0.3645vw;
      }
      .img-3 {
        width: 3.5416vw;
        bottom: 0.10416vw;
      }
      .img-4 {
        width: 3.5416vw;
        bottom: 0.8854vw;
        z-index: 9;
      }
      .img-5 {
        width: 3.5416vw;
        bottom: 1.40625vw;
        z-index: 9;
      }
      .img-6 {
        width: 1.979vw;
        bottom: 0.9375vw;
      }
      .img-7 {
        width: 2.708vw;
        bottom: 0.9895vw;
      }
    }
    .name {
      font-size: 12px;
      color: white;
      text-align: center;
      padding-top: 0.5208vw;
    }
  }
</style>
